import React, { Component } from "react";
import { Modal, Row, Col, Button, Form, FormGroup, FormControl, ControlLabel, Checkbox } from "react-bootstrap";
import Functions from "../../../src/util/functions";

export default class LoginModal extends Component {
    render() {
        return (
            <Modal className="login-modal" show={this.props.showModal} onHide={this.props.closeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Enter your details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="error-message">{this.props.errorMessage}</div>
                    <Form action="/users/sign_in" method="POST">
                        <FormControl type="hidden" placeholder="Name" name="authenticity_token" value={Functions.getMetaContent("csrf-token")} />

                        <FormGroup controlId="formHorizontalEmail">
                            <FormControl type="email" placeholder="E-mail" name="user[email]" required />
                        </FormGroup>

                        <FormGroup controlId="formHorizontalPassword">
                            <FormControl type="password" placeholder="Password" name="user[password]" required />
                        </FormGroup>

                        <FormGroup controlId="formHorizontalRememberMe">
                            <Checkbox name="user[remember_me]">Remember me</Checkbox>
                        </FormGroup>

                        <div className="links">
                            <a href="/users/password/new">Forgotten your password?</a>
                        </div>

                        <FormGroup>
                            <Button type="submit" onClick={this.props.handleLoginSubmit}>Log in</Button>
                        </FormGroup>
                    </Form>
                </Modal.Body>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/LoginModal.jsx.erb